export var Products;
(function (Products) {
    Products["Sitemate"] = "Sitemate";
    Products["Dashpivot"] = "Dashpivot";
    Products["Flowsite"] = "Flowsite";
})(Products || (Products = {}));
